<template>
  <div id="coastMap">
    <!-- Modal Structure -->
    <div id="modal" class="modal modal-fixed-footer" ref="modal">
      <div class="modal-header">
        <div class="header-title">Map Tool</div>
        <button class="btn-floating z-depth-0 transparent waves-effect" @click="showTipBox = true" style="position:absolute; right: 10px; top: 6px;">
          <i class="material-icons grey-text text-darken-3">info_outline</i>
        </button>
      </div>
      <div class="use-info z-depth-1" v-show="showTipBox">
          <div class="title">How to use</div> 
          <button @click="showTipBox = false" class="btn-floating transparent z-depth-0 btn-small close-preview">
            <i class="material-icons grey-text text-darken-3">close</i> </button>          
          <ol>
          <li>Click on the <b>Home icon <i class="material-icons">home</i></b> on the right to find your location.</li>
          <li>Move coast marker (green marker) to your estimated nearest coast.</li>
        </ol>
      </div>
 
        <div class="calculated-overlay" v-if="coastdistance.miles" >
          <div class="overlay-title">Calculated Distance</div>
          {{ coastdistance.meters.toFixed(0) }} Meters <br>
          
          {{ coastdistance.kilometers.toFixed(2) }} kilometeres <br>
          {{ coastdistance.miles.toFixed(2) }} Miles
      
        </div>
      <div class="modal-content">
        <GmapMap :center="center" :zoom="mapZoom" map-style-id="roadmap" :options="mapOptions" ref="mapRef" >
          <GmapMarker
            class="markerStyle"
            
            :icon="homeIcon"
            :position="markers.home.position"
            @mouseover="statusText = markers.home.title"
            @mouseout="statusText = null"
            :clickable="true"
            :draggable="true"
            @drag="homeMarkerDrag"
            @click="toggleInfoWindow(markers.home, 0)"
          />

          <GmapMarker
             
             :icon="waterIcon"
            :position="markers.coast.position"
            :clickable="true"
            @mouseover="statusText = markers.coast.title"
            @mouseout="statusText = null"
            :draggable="true"
            @drag="coastMarkerDrag"
            @click="toggleInfoWindow(markers.coast, 1)"
          />
          <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen = false"> </gmap-info-window>
          <GmapPolyline :path="[markers.home.position, markers.coast.position]" />
      <!--     <div slot="visible">
            <div class="amber accent-2" style="top:0; right: 0; background-color:; color: white; position: absolute; z-index: 100; font-size: 20px; width: 80px; text-align:center;">
              {{ statusText }}
            </div>
          </div> -->
        </GmapMap>
        <button class="btn-floating white waves-effect maps-btn pulse" @click="geolocate()">
          <i class="material-icons-outlined grey-text text-darken-3">home</i>
        </button>
      </div>
      <div class="modal-footer">
        <button class="modal-close waves-effect waves-green btn-flat" >Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import waterIcon from '@/assets/water.png'
import homeIcon from '@/assets/home.png'
export default {
  name: "googleMaps",
  components: {},
  data() {
    return {
      waterIcon,
      homeIcon,
      modal: {
        instance: null,
        options: {
          onCloseEnd: () =>{
              this.$emit('state', false)
          }
        },
      },
      showTipBox: true,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      markers: {
        home: { position: { lat: 13.909444, lng: -60.978893 }, title: "Home Marker" },
        coast: { position: { lat: 13.853366983409916, lng: -60.988893 }, title: "Coast Marker" },
      },
      statusText: null,
      center: { lat: 13.909444, lng: -60.978893 },
      mapZoom: 11,
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: true,
      },
      coastdistance: {
        miles: null,
        kilometers: null,
        meters: null,
      },
    };
  },
  mounted() {
    this.$_initModal();
  },
  beforeDestroy(){
    if (this.modal.instance) {
    this.modal.instance.close()
    this.modal.instance.destroy
    }
    
  },
  destroyed(){

  },
  methods: {
    $_initModal() {
      this.modal.instance = M.Modal.init( this.$refs.modal, this.modal.options);
      this.modal.instance.open();
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.title;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }

      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    sendDistance() {
      this.modal.instance.close()
      //this.$emit("distanceUpdate");
    },
    $_haversine_distance(mk1, mk2) {
      var miles = 3958.8; // Radius of the Earth in miles
      var kilom = 6371.071; // Radius of the Earth in kilometers
      var meters = 6000000.371; // Radius of the earth in meters
      var rlat1 = mk1.position.lat * (Math.PI / 180); // Convert degrees to radians
      var rlat2 = mk2.position.lat * (Math.PI / 180); // Convert degrees to radians
      var difflat = rlat2 - rlat1; // Radian difference (latitudes)
      var difflon = (mk2.position.lng - mk1.position.lng) * (Math.PI / 180); // Radian difference (longitudes)

      this.coastdistance.miles = 2 * miles * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
      this.coastdistance.meters = 2 * meters * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
      this.coastdistance.kilometers =
        2 * kilom * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.markers.home.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
      setTimeout(() => {
        this.panToMarker();
      }, 500);
    },

    //sets the position of marker when dragged
    // handleMarkerDrag(e) {
    //   this.markers.home.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    // },
    homeMarkerDrag(e) {
      this.markers.home.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      this.$_haversine_distance(this.markers.home, this.markers.coast);
    },
    coastMarkerDrag(e) {
      this.markers.coast.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      this.$_haversine_distance(this.markers.home, this.markers.coast);
    },

    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.markers.home.position);
      this.mapZoom = 12;
    },

    //Moves the marker to click position on the map
    handleMapClick(e) {
      this.markers.coast.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      this.$_haversine_distance(this.markers.home, this.markers.coast);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  width:100%;
  max-width: 768px;
  height: 95%;
  max-height:768px;
  top: 2.5% !important;
  .modal-header {
    height: 48px;
    padding-left: 12px;
    .header-title {
      font-size: 18px;
      line-height: 50px;
    }
  }
    .modal-content {
      height: calc(100% - 96px);
      padding: 0;
    }
  
}
.markers {
  width: 50px;
}
.close-preview {
  position: absolute;
  right: 12px; top: 8px;
}
#coastMap {
  .vue-map-container {
    height: 100%;
    position:absolute;
    left:0;
    top:0;
    width: 100%;
  }
}
.maps-btn {
  position: absolute;
  right: 10px; 
  bottom: 120px;
}
.markerStyle {
  background-color: green;
}
.use-info {
    position: absolute;
    bottom: 66px;
    left: 16px;
    background: white;
    height: auto;
    max-width: 520px;
    z-index: 10;
    width: calc(100% - 80px);
    border-radius: 6px;
    padding: 15px;
  .title {
    font-size: 19px;
    font-weight: 500;
    line-height: 1;
    margin-bottom: 12px;
  }
  ol {
    padding: 0px 0 0 20px;
    margin: 0;
    font-size: 14px;
    li {
      line-height: 1.4;
    }
  }
}
.calculated-overlay {
  position: absolute;
  bottom: 72px;
  left: 16px;
  width: 270px;
  z-index: 9;
  background: white;
  padding: 16px;
  border-radius: 6px;
}
</style>
